import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const getCurrentUser = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    const path = '/api/ws-permissions/users/current-user';
    const pathInternal = '/api/users/current-user';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.selectedCompanyId !== undefined) {
        urlParams.append('selectedCompanyId', params.selectedCompanyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCurrentUser.paramsOrder = [{ type: 'parameters' }];
export const getUserByEmailWithPermissions = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.email === undefined) {
        throw new Error('Missing required parameter: email');
    }
    const path = '/api/ws-permissions/user-with-permissions/by-email';
    const pathInternal = '/api/user-with-permissions/by-email';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.email !== undefined) {
        urlParams.append('email', params.email.toString());
    }
    if (params.selectedCompanyId !== undefined) {
        urlParams.append('selectedCompanyId', params.selectedCompanyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserByEmailWithPermissions.paramsOrder = [{ type: 'parameters' }];
export const getUserAdministratingCompanies = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    const path = '/api/ws-permissions/users/{userId}/administrating-companies'.replace('{userId}', params.userId?.toString());
    const pathInternal = '/api/users/{userId}/administrating-companies'.replace('{userId}', params.userId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserAdministratingCompanies.paramsOrder = [{ type: 'parameters' }];
export const updateAdministratingCompanies = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    if (params.companyIds === undefined) {
        throw new Error('Missing required body: companyIds');
    }
    const path = '/api/ws-permissions/users/{userId}/administrating-companies'.replace('{userId}', params.userId?.toString());
    const pathInternal = '/api/users/{userId}/administrating-companies'.replace('{userId}', params.userId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyIds !== undefined) {
        body = params.companyIds;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateAdministratingCompanies.paramsOrder = [
    { type: 'body', paramName: 'companyIds' },
    { type: 'parameters' },
];
export const updateCompanyAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.accountIds === undefined) {
        throw new Error('Missing required body: accountIds');
    }
    const path = '/api/ws-permissions/companies/{companyId}/accounts'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/accounts'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIds !== undefined) {
        body = params.accountIds;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateCompanyAccounts.paramsOrder = [{ type: 'body', paramName: 'accountIds' }, { type: 'parameters' }];
export const updateCompanyWebsites = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.websiteIds === undefined) {
        throw new Error('Missing required body: websiteIds');
    }
    const path = '/api/ws-permissions/companies/{companyId}/websites'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/websites'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.websiteIds !== undefined) {
        body = params.websiteIds;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateCompanyWebsites.paramsOrder = [{ type: 'body', paramName: 'websiteIds' }, { type: 'parameters' }];
export const getCompanyPermissions = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/permissions'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPermissions.paramsOrder = [{ type: 'parameters' }];
export const updateCompanyPermissions = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/permissions'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateCompanyPermissions.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const getCompaniesPermissions = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.companyIds === undefined) {
        throw new Error('Missing required parameter: companyIds');
    }
    const path = '/api/ws-permissions/companies/permissions/by-ids';
    const pathInternal = '/api/companies/permissions/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyIds !== undefined) {
        urlParams.append('companyIds', params.companyIds.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompaniesPermissions.paramsOrder = [{ type: 'parameters' }];
export const getCompanyPermissionsIncludeInactive = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions/include-inactive'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/permissions/include-inactive'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPermissionsIncludeInactive.paramsOrder = [{ type: 'parameters' }];
export const hasCompanyPermission = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.permission === undefined) {
        throw new Error('Missing required parameter: permission');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions/check'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/permissions/check'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.permission !== undefined) {
        urlParams.append('permission', params.permission.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
hasCompanyPermission.paramsOrder = [{ type: 'parameters' }];
export const hasCompanyPermissionByUUID = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.companyUUID === undefined) {
        throw new Error('Missing required parameter: companyUUID');
    }
    if (params.permission === undefined) {
        throw new Error('Missing required parameter: permission');
    }
    const path = '/api/ws-permissions/companies/{companyUUID}/permissions/check-by-uuid'.replace('{companyUUID}', params.companyUUID?.toString());
    const pathInternal = '/api/companies/{companyUUID}/permissions/check-by-uuid'.replace('{companyUUID}', params.companyUUID?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.permission !== undefined) {
        urlParams.append('permission', params.permission.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
hasCompanyPermissionByUUID.paramsOrder = [{ type: 'parameters' }];
export const getAllManagingCompaniesIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.permissions === undefined) {
        throw new Error('Missing required parameter: permissions');
    }
    const path = '/api/ws-permissions/companies/{companyId}/managing-companies-ids'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/managing-companies-ids'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.permissions !== undefined) {
        urlParams.append('permissions', params.permissions.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllManagingCompaniesIds.paramsOrder = [{ type: 'parameters' }];
export const getAllManagingCompaniesNames = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.permissions === undefined) {
        throw new Error('Missing required parameter: permissions');
    }
    const path = '/api/ws-permissions/companies/{id}/managing-companies-names'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/companies/{id}/managing-companies-names'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.permissions !== undefined) {
        urlParams.append('permissions', params.permissions.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllManagingCompaniesNames.paramsOrder = [{ type: 'parameters' }];
export const getManagedByCompany = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.permission === undefined) {
        throw new Error('Missing required parameter: permission');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions/managed-by'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/permissions/managed-by'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.permission !== undefined) {
        urlParams.append('permission', params.permission.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getManagedByCompany.paramsOrder = [{ type: 'parameters' }];
export const getCompanyPermissionsSummary = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions/summary'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/permissions/summary'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.userId !== undefined) {
        urlParams.append('userId', params.userId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPermissionsSummary.paramsOrder = [{ type: 'parameters' }];
export const getUserHeaderHash = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    const path = '/api/ws-permissions/companies/{companyId}/permissions/summary/hash'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/permissions/summary/hash'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.userId !== undefined) {
        urlParams.append('userId', params.userId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserHeaderHash.paramsOrder = [{ type: 'parameters' }];
export const getPermittedWebsiteCompanyIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-permissions/websites/{websiteId}/company-ids'.replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/websites/{websiteId}/company-ids'.replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPermittedWebsiteCompanyIds.paramsOrder = [{ type: 'parameters' }];
export const getPaginatedCompaniesNames = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    const path = '/api/ws-permissions/company/names/paginated';
    const pathInternal = '/api/company/names/paginated';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.size !== undefined) {
        urlParams.append('size', params.size.toString());
    }
    if (params.sortDirection !== undefined) {
        urlParams.append('sortDirection', params.sortDirection.toString());
    }
    if (params.sortProperties !== undefined) {
        urlParams.append('sortProperties', params.sortProperties.toString());
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedCompaniesNames.paramsOrder = [{ type: 'parameters' }];
export const getPermissionTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    const path = '/api/ws-permissions/permission-types';
    const pathInternal = '/api/permission-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPermissionTypes.paramsOrder = [];
export const getCompanyIdsWithActivePermissions = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.permission === undefined) {
        throw new Error('Missing required parameter: permission');
    }
    const path = '/api/ws-permissions/permissions/company-ids';
    const pathInternal = '/api/permissions/company-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.permission !== undefined) {
        urlParams.append('permission', params.permission.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyIdsWithActivePermissions.paramsOrder = [{ type: 'parameters' }];
export const getAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    const path = '/api/ws-permissions/accounts';
    const pathInternal = '/api/accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.order !== undefined) {
        urlParams.append('order', params.order.toString());
    }
    if (params.sort !== undefined) {
        urlParams.append('sort', params.sort.toString());
    }
    if (params.nameFilter !== undefined) {
        urlParams.append('nameFilter', params.nameFilter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccounts.paramsOrder = [{ type: 'parameters' }];
export const getAccountsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.accountIds === undefined) {
        throw new Error('Missing required body: accountIds');
    }
    const path = '/api/ws-permissions/accounts/by-ids';
    const pathInternal = '/api/accounts/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIds !== undefined) {
        body = params.accountIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountsByIds.paramsOrder = [{ type: 'body', paramName: 'accountIds' }];
export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-permissions/accounts/replace-account-id';
    const pathInternal = '/api/accounts/replace-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
export const getUserRoles = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-permissions/user-roles';
    const pathInternal = '/api/user-roles';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserRoles.paramsOrder = [{ type: 'parameters' }];
export const createUserRole = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-permissions/user-roles';
    const pathInternal = '/api/user-roles';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
createUserRole.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const updateUserRole = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-permissions/user-roles/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/user-roles/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateUserRole.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const enableUserRole = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.status === undefined) {
        throw new Error('Missing required parameter: status');
    }
    const path = '/api/ws-permissions/user-roles/{id}/enable'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/user-roles/{id}/enable'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.status !== undefined) {
        urlParams.append('status', params.status.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
enableUserRole.paramsOrder = [{ type: 'parameters' }];
export const getRolesByUser = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    const path = '/api/ws-permissions/user-roles/by-user';
    const pathInternal = '/api/user-roles/by-user';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.userId !== undefined) {
        urlParams.append('userId', params.userId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getRolesByUser.paramsOrder = [{ type: 'parameters' }];
export const assignUserRoles = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.userRoleIds === undefined) {
        throw new Error('Missing required body: userRoleIds');
    }
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    const path = '/api/ws-permissions/user-roles/by-user';
    const pathInternal = '/api/user-roles/by-user';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.userRoleIds !== undefined) {
        body = params.userRoleIds;
    }
    if (params.userId !== undefined) {
        urlParams.append('userId', params.userId.toString());
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'void',
        requestType: 'json',
    });
};
assignUserRoles.paramsOrder = [{ type: 'body', paramName: 'userRoleIds' }, { type: 'parameters' }];
export * from './types';
export * from './constants';
